import { ARCHITECTURE_ID } from './common'

function architectureMatch(array) {
	let result = array.reduce(
		(accum, current, index) => {
			if (!accum.continue) {
				return accum
			}
			if (index === 0 && current.id === ARCHITECTURE_ID) {
				accum.continue = false
			}
			if (accum.comparison && current.percentage !== accum.comparison) {
				accum.continue = false
				return accum
			}
			if (current.id === ARCHITECTURE_ID) {
				accum.reformat = true
			}
			accum.comparison = current.percentage
			return accum
		},
		{ continue: true, comparison: null, reformat: false }
	)
	return result.reformat
}

export default architectureMatch
